import { STATUS } from "@/constants/statuses";
import AttributesEntity from "@apps/reviews/entities/AttributesEntity";
import { AttributesSchema } from "@apps/reviews/schemas/AttributesSchema";
import AttributesStore from "@apps/reviews/widgets/review_form_modal_widget/stores/AttributesStore";
import { applyTransaction } from "@datorama/akita";
import ApiClientInterface from "@lib/ApiClient/ApiClientInterface";
import { Observable } from "rxjs";
import { catchError, map, tap } from "rxjs/operators";
import { create } from "superstruct";

import { LoggerInterface } from "@interfaces/LoggerInterface";

export default class AttributesService {
    constructor(
        private readonly attributesStore: AttributesStore,
        private readonly apiClient: ApiClientInterface,
        private readonly logger: LoggerInterface
    ) {}

    getAttributesByProductId(productId: number): Observable<AttributesEntity> {
        this.logger.debug("AttributesService.getAttributesByProductId", {
            productId,
        });

        return this.apiClient
            .get({
                url: "/review/getAttributes",
                queryParams: {
                    productId,
                },
                responseType: "json",
            })
            .pipe(
                map((response) => {
                    return create(response.body, AttributesSchema);
                }),
                catchError((error: unknown) => {
                    this.logger.debug(
                        "AttributesService.getAttributesByProductId is errored",
                        { error }
                    );
                    this.attributesStore.setStatus(STATUS.ERROR);
                    throw error;
                }),
                tap((data) => {
                    this.logger.debug(
                        "AttributesService.getAttributesByProductId is ready"
                    );

                    applyTransaction(() => {
                        this.attributesStore.update((state) => ({
                            ...state,
                            attributes: data,
                        }));
                        this.attributesStore.setStatus(STATUS.READY);
                    });
                })
            );
    }

    resetAttributesStore() {
        this.attributesStore.reset();
    }
}
